var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"rotate":90,"size":70,"width":7,"value":_vm.value,"color":"purple"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }